module.exports = __webpack_public_path__ + "static/media/YM50_4.18cc7488.jpg";